import fitty from 'fitty';

common.View.create('canvas.blocks.custom.header.Block', {

    onDOMLoad() {
        this.initFitText();
    },

    initFitText() {
        fitty('.fitText div > *', {
            minSize: 12,
            multiLine: false
        });
    }

});
